.uppercase-label {
    font-size: 12px;
    line-height: 21px;
    font-weight: 500;
    color: var(--grey);
    text-transform: uppercase;
}
